import React, { useState, useEffect } from "react";
import "./LeaveApplicationHRTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

export default function LeaveApplicationHRTable(props) {
  const [leaveApplicationHRData, setLeaveApplicationHRData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    const loadLeaveApplicationHRDataInitial = async () => {
      axios
        .get(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/leave-application-hr/",
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((response) => {
          // leaveApplicationHRObj = response.data;
          // console.log("response", response.data);
          setLeaveApplicationHRData(response.data);

          setLoading(false);

          let rowDataTT = [];

          response.data.forEach((data) => {
            let temp = {
              data,
              EmployeeCode: data["employee"][0]["EmployeeCode"],
              Name:
                data["employee"][0]["FirstName"] +
                " " +
                data["employee"][0]["LastName"],
              Leavetype: data["Leavetype"],
              FromDate: data["FromDate"].slice(0, 10),
              ToDate: data["ToDate"].slice(0, 10),
              Reasonforleave: data["Reasonforleave"],
              Status: status(data["Status"]),
            };

            rowDataTT.push(temp);
          });

          setRowData(rowDataTT);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    loadLeaveApplicationHRDataInitial();
  }, []);
  const renderEditButton = (params) => {
    // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faEdit}
        onClick={() => props.onEditLeaveApplicationHR(params.data.data)}
      />
    );
  };

  const renderButton = (params) => {
    // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() =>
          onLeaveApplicationHRDelete(
            params.data.data["employee"][0]["_id"],
            params.data.data["_id"]
          )
        }
      />
    );
  };

  const columnDefs = [
    {
      headerName: "Emloyee Code",
      field: "EmployeeCode",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "Name",
      field: "Name",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "Leave type",
      field: "Leavetype",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "From Date",
      field: "FromDate",
      sortable: true,
      filter: true,
      // type: ["dateColumn"],
    },
    {
      headerName: "To Date",
      field: "ToDate",
      sortable: true,
      filter: true,
      // type: ["dateColumn"],
    },
    {
      headerName: "Reasonforleave",
      field: "Reasonforleave",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "Status",
      field: "Status",
      sortable: true,
      // filter: true ,
    },

    {
      headerName: "",
      field: "edit",
      filter: false,
      width: 30,
      cellRendererFramework: renderEditButton,
    },
    {
      headerName: "",
      field: "delete",
      filter: false,
      width: 30,
      cellRendererFramework: renderButton,
    },
  ];

  const defaultColDef = {
    resizable: true,
    width: 170,
    filter: "agTextColumnFilter",
    // filter: true ,
  };
  const getRowHeight = 35;
  // let leaveApplicationHRObj = [];
  let rowDataT = [];

  const loadLeaveApplicationHRData = () => {
    axios
      .get(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-application-hr/",
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((response) => {
        // leaveApplicationHRObj = response.data;
        // console.log("response", response.data);
        setLeaveApplicationHRData(response.data);
        setLoading(false);

        rowDataT = [];

        leaveApplicationHRData.forEach((data) => {
          let temp = {
            data,
            EmployeeCode: data["employee"][0]["EmployeeCode"],
            Name:
              data["employee"][0]["FirstName"] +
              " " +
              data["employee"][0]["LastName"],
            Leavetype: data["Leavetype"],
            FromDate: data["FromDate"].slice(0, 10),
            ToDate: data["ToDate"].slice(0, 10),
            Reasonforleave: data["Reasonforleave"],
            Status: status(data["Status"]),
          };

          rowDataT.push(temp);
        });
        setRowData(rowDataT);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onLeaveApplicationHRDelete = (e1, e2) => {
    // console.log(e1, e2);
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/leave-application-hr/" +
            e1 +
            "/" +
            e2,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          loadLeaveApplicationHRData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const status = (s) => {
    if (s === 1) {
      return "Pending";
    }
    if (s === 2) {
      return "Approved";
    }
    if (s === 3) {
      return "Rejected";
    }
  };

  return (
    <div id="table-outer-div-scroll">
      <h2 id="role-title">Employee Leave Application Details</h2>

      <div id="clear-both" />
      {!loading ? (
        <div id="table-div" className="ag-theme-balham">
          <AgGridReact
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowData={rowData}
            pagination={true}
            paginationPageSize={10}
            getRowHeight={getRowHeight}
          />
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </div>
  );
}
